const OtherpageHome = () => {

    return (
        <>
        </>
    )

};

export default OtherpageHome;